module.exports = __webpack_public_path__ + "static/media/Motorola Moto 360 Women Gold + Blush Closed.a71c7b88.png";